import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

const subgroups = [
  {
    abbr: 'APPSN',
    name: 'Association of Private Practising Surveyors of Nigeria',
    description: 'A group of Surveyors in private practice, i.e. not employed by any government parastatal or private company. They are charged with the responsibility of providing survey services to individuals and corporate organizations. This is the largest subgroup of the NIS.',
    color: '#0B5D1E',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
  },
  {
    abbr: 'WIS',
    name: 'Women in Surveying',
    description: 'Every female who is qualified to be a member of NIS. WIS is dedicated to promoting gender inclusivity and empowering women in the surveying profession through mentorship, networking, and professional development opportunities.',
    color: '#9333EA',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    abbr: 'YSN',
    name: 'Young Surveyors Network',
    description: 'The Young Surveyors Network (YSN) is a subgroup of the Nigerian Institution of Surveyors (NIS) and a member of the Young Surveyors Africa Network (YSN Africa) under the FIG-YSN International. YSN promotes national and international opportunities among young minds, provides a forum for sharing ideas, knowledge, skills, and experience, and seeks to create innovation that helps achieve the Sustainable Development Goals.',
    color: '#C8A951',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    ),
  },
];

function DefaultContent() {
  return (
    <>
      {/* Hero */}
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              NIS Subgroups
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              The Nigerian Institution of Surveyors is organized into specialized subgroups that cater to different aspects of the surveying profession.
            </p>
          </div>
        </div>
      </section>

      {/* Subgroups */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="space-y-8">
            {subgroups.map((sg) => (
              <div key={sg.abbr} className="bg-[#F8FAFB] rounded-2xl border border-gray-100 shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                <div className="p-8 md:flex md:items-start md:gap-6">
                  <div className="flex-shrink-0 mb-4 md:mb-0">
                    <div className="w-16 h-16 rounded-xl flex items-center justify-center" style={{ backgroundColor: sg.color + '15', color: sg.color }}>
                      {sg.icon}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-3 mb-3">
                      <span className="inline-block px-3 py-1 rounded-full text-xs font-bold tracking-wide text-white" style={{ backgroundColor: sg.color }}>
                        {sg.abbr}
                      </span>
                      <h2 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display',serif" }}>
                        {sg.name}
                      </h2>
                    </div>
                    <p className="text-gray-600 leading-relaxed">{sg.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default function Subgroup() {
  return <PageRenderer pageKey="subgroup" fallback={<DefaultContent />} />;
}
